import createVueComponent from '../createVueComponent';

const ChevronDownCircle = createVueComponent('ChevronDownCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'm16 10-4 4-4-4', key: '894hmk' }],
]);

export default ChevronDownCircle;
